export const RANK_RANK_APPS_REQUEST = 'RANK_RANK_APPS_REQUEST';
export const RANK_RANK_APPS_SUCCESS = 'RANK_RANK_APPS_SUCCESS';
export const RANK_RANK_APPS_FAILURE = 'RANK_RANK_APPS_FAILURE';

export const RANK_RANKS_REQUEST = 'RANK_RANKS_REQUEST';
export const RANK_RANKS_SUCCESS = 'RANK_RANKS_SUCCESS';
export const RANK_RANKS_FAILURE = 'RANK_RANKS_FAILURE';

export const OTHER_RANK_APPS_REQUEST = 'OTHER_RANK_APPS_REQUEST';
export const OTHER_RANK_APPS_SUCCESS = 'OTHER_RANK_APPS_SUCCESS';
export const OTHER_RANK_APPS_FAILURE = 'OTHER_RANK_APPS_FAILURE';
